import { NotificationManager } from 'react-notifications';

export const sendErrorNotification = (message, duration = 1000) => {
  NotificationManager.removeAll();
  NotificationManager.error(message, null, duration);
};

export const sendInfoNotification = (message, duration = 1000) => {
  NotificationManager.removeAll();
  NotificationManager.info(message, null, duration);
};

export const sendWarningNotification = (message, duration = 1000) => {
  NotificationManager.removeAll();
  NotificationManager.warning(message, null, duration);
};

export const sendSuccessNotification = (message, duration = 1000) => {
  NotificationManager.removeAll();
  NotificationManager.success(message, null, duration);
};
